(function () {
  const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const asArray = (value) => (Array.isArray(value) ? value : []);

  const getItems = (payload) => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    const data = payload.data || payload;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data.data)) return data.data;
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.reviews)) return data.reviews;
    if (Array.isArray(data.docs)) return data.docs;
    if (Array.isArray(data.results)) return data.results;
    return asArray(payload.reviews || payload.items);
  };

  const getStats = (payload) => {
    const data = payload && (payload.data || payload);
    return asArray(data && data.stats);
  };

  const getCount = (payload, fallback) => {
    if (payload == null) return fallback;
    if (typeof payload === 'number') return payload;
    const data = payload.data != null ? payload.data : payload;
    const value =
      (typeof data === 'number' && data) ||
      data.count ||
      data.total ||
      data.total_count ||
      (data.countsum && data.countsum.count) ||
      payload.count ||
      payload.total;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const readConfig = () => {
    const node = document.getElementById('bagveda-nector-config');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return {};
    }
  };

  const toStarsHtml = (rating, size) => {
    const value = Number(rating) || 0;
    const filled = Math.round(value);
    const stars = [1, 2, 3, 4, 5]
      .map(
        (index) =>
          `<span class="bagveda-star-rating__star${index <= filled ? ' is-filled' : ''}"></span>`
      )
      .join('');
    return `<div class="bagveda-star-rating" style="--bagveda-star-size: ${size || 16}px;" role="img" aria-label="${value} out of 5 stars">${stars}</div>`;
  };

  const formatDate = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return `${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
  };

  const firstSentence = (text) => {
    const value = String(text || '').trim();
    if (!value) return '';
    const match = value.match(/^[^.!?]+[.!?]?/);
    const sentence = (match ? match[0] : value).trim();
    return sentence.length > 72 ? `${sentence.slice(0, 69).trim()}…` : sentence;
  };

  const normalizeReview = (review) => {
    const body =
      review.description ||
      review.body ||
      review.text ||
      review.review ||
      review.content ||
      '';
    const images = review.uploads || review.image_links || review.images || review.media || [];
      const image = Array.isArray(images)
      ? images[0] && (images[0].url || images[0].src || images[0])
      : images;
    const imageUrl = typeof image === 'string' && /^https?:/i.test(image) ? image : '';
    const verified = review.is_verified === true || review.is_verified === 'true' || review.verified === true;
    const hidden = review.is_hidden === true || review.is_approved === false || review.status === 'hidden' || review.visibility === 'hidden';

    return {
      rating: Number(review.rating || review.stars || 0),
      title: review.title || review.heading || firstSentence(body),
      body,
      author: review.name || review.author || review.lead_name || review.customer_name || '',
      date: formatDate(review.posted_at || review.created_at || review.createdAt || review.date),
      image: imageUrl,
      verified,
      hidden,
    };
  };

  const replaceCount = (template, count) => String(template || '').replace(/\[count\]/g, String(count));

  const init = (root) => {
    const productId = root.getAttribute('data-product-id');
    if (!productId) return;

    const config = readConfig();
    if (!config.apiKey && window.bagvedaNector && typeof window.bagvedaNector.resolveApiKey === 'function') {
      config.apiKey = window.bagvedaNector.resolveApiKey();
    }
    const previewLimit = Number(root.getAttribute('data-preview-limit') || 2);
    const allowAllFallback = root.getAttribute('data-fallback-all') === 'true';
    const preview = root.querySelector('[data-bagveda-reviews-preview]');
    const allList = root.querySelector('[data-bagveda-reviews-all]');
    const summary = root.querySelector('[data-bagveda-reviews-summary]');
    const footer = root.querySelector('[data-bagveda-reviews-footer]');
    const showAllBtn = root.querySelector('[data-bagveda-pdp-reviews-show-all]');
    const status = root.querySelector('[data-bagveda-reviews-status]');
    const modal = root.querySelector('[data-bagveda-reviews-modal]');
    const loadMoreBtn = root.querySelector('[data-bagveda-reviews-load-more]');
    const template = root.querySelector('[data-bagveda-review-card-template]');

    let reviews = [];
    let totalCount = 0;
    let stats = [];
    let leadToken = null;
    let includeWorkspace = Boolean(config.workspaceId);
    let scopedToProduct = true;
    let sort = 'posted_at';
    let page = 1;
    let loading = false;

    const setStatus = (message) => {
      if (!status) return;
      if (!message) {
        status.hidden = true;
        status.textContent = '';
        return;
      }
      status.hidden = false;
      status.textContent = message;
    };

    const fillCard = (node, review) => {
      const stars = node.querySelector('.bagveda-star-rating');
      if (stars) stars.outerHTML = toStarsHtml(review.rating, 16);

      const verified = node.querySelector('.bagveda-pdp-review-card__verified');
      if (verified) verified.hidden = !review.verified;

      const title = node.querySelector('[data-bagveda-review-title]');
      if (title) {
        title.textContent = review.title;
        title.hidden = !review.title;
      }

      const photo = node.querySelector('[data-bagveda-review-photo]');
      if (photo) {
        if (review.image) {
          photo.hidden = false;
          photo.innerHTML = `<img src="${review.image.replace(/"/g, '&quot;')}" alt="" width="56" height="56" loading="lazy">`;
        } else {
          photo.hidden = true;
          photo.innerHTML = '';
        }
      }

      const body = node.querySelector('[data-bagveda-review-body]');
      if (body) {
        body.textContent = review.body;
        body.hidden = !review.body;
      }

      const footerEl = node.querySelector('[data-bagveda-review-footer]');
      const author = node.querySelector('[data-bagveda-review-author]');
      const date = node.querySelector('[data-bagveda-review-date]');
      const separator = node.querySelector('[data-bagveda-review-separator]');
      if (author) author.textContent = review.author;
      if (date) date.textContent = review.date;
      if (separator) separator.hidden = !(review.author && review.date);
      if (footerEl) footerEl.hidden = !(review.author || review.date);
    };

    const createCard = (review) => {
      const source = template && template.content.querySelector('.bagveda-pdp-review-card');
      if (!source) return document.createElement('article');
      const node = source.cloneNode(true);
      fillCard(node, review);
      return node;
    };

    const renderList = (target, items) => {
      if (!target || !template) return;
      target.replaceChildren();
      items.forEach((review) => target.appendChild(createCard(review)));
    };

    const updateHeaderRating = (average, count) => {
      document.querySelectorAll('[data-bagveda-pdp-rating]').forEach((ratingRoot) => {
        const score = ratingRoot.querySelector('[data-bagveda-pdp-rating-score]');
        const countEl = ratingRoot.querySelector('[data-bagveda-pdp-rating-count]');
        const stars = ratingRoot.querySelector('.bagveda-star-rating');
        if (score) score.textContent = average;
        if (countEl) countEl.textContent = replaceCount(root.getAttribute('data-rating-count-label'), count);
        if (stars) stars.outerHTML = toStarsHtml(average, 14);
      });
    };

    const updateSummary = (items, count, stats) => {
      const histogram = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      let ratedCount = 0;
      let sum = 0;

      if (stats.length) {
        stats.forEach((row) => {
          const rating = Math.min(5, Math.max(1, Math.round(Number(row.rating))));
          const rowCount = Number(row.count || 0);
          histogram[rating] += rowCount;
          ratedCount += rowCount;
          sum += rating * rowCount;
        });
      } else {
        items.forEach((review) => {
          const rating = Math.min(5, Math.max(1, Math.round(review.rating)));
          histogram[rating] += 1;
          ratedCount += 1;
          sum += review.rating;
        });
      }

      const average = ratedCount ? (sum / ratedCount).toFixed(1) : '0.0';
      const averageEl = root.querySelector('[data-bagveda-reviews-average]');
      const starsWrap = root.querySelector('[data-bagveda-reviews-average-stars]');
      const verifiedCount = root.querySelector('[data-bagveda-reviews-verified-count]');

      if (averageEl) averageEl.textContent = average;
      if (starsWrap) starsWrap.innerHTML = toStarsHtml(average, 16);
      if (verifiedCount) {
        verifiedCount.textContent = replaceCount(root.getAttribute('data-verified-label'), count);
      }

      [5, 4, 3, 2, 1].forEach((level) => {
        const row = root.querySelector(`[data-bagveda-review-bar="${level}"]`);
        if (!row) return;
        const percent = ratedCount > 0 ? Math.round((histogram[level] / ratedCount) * 100) : 0;
        const fill = row.querySelector('[data-bagveda-review-bar-fill]');
        const value = row.querySelector('[data-bagveda-review-bar-value]');
        if (fill) fill.style.width = `${percent}%`;
        if (value) value.textContent = `${percent}%`;
      });

      if (summary) summary.hidden = count === 0;
      updateHeaderRating(average, count);
    };

    const syncShowAll = () => {
      if (!showAllBtn || !footer) return;
      const label = replaceCount(root.getAttribute('data-show-all-label'), totalCount);
      showAllBtn.textContent = label;
      footer.hidden = totalCount <= previewLimit;
    };

    const waitForLeadToken = (timeoutMs = 8000) => {
      return new Promise((resolve) => {
        const readToken = () => window.nector?.lead_token || window.nector?.leadToken || null;
        if (readToken()) {
          resolve(readToken());
          return;
        }
        const started = Date.now();
        const timer = window.setInterval(() => {
          const token = readToken();
          if (token || Date.now() - started >= timeoutMs) {
            window.clearInterval(timer);
            resolve(token);
          }
        }, 200);
      });
    };

    const buildHeaders = () => {
      const result = {
        Accept: 'application/json',
        'x-apikey': config.apiKey,
        'x-source': 'web',
      };
      if (includeWorkspace && config.workspaceId) result['x-workspaceid'] = config.workspaceId;
      if (leadToken) result['x-leadtoken'] = leadToken;
      return result;
    };

    const isAuthFailure = (response, payload) => {
      if (response.status === 401 || response.status === 403) return true;
      const code = payload && payload.meta && payload.meta.code;
      return code === 401 || code === 403;
    };

    const merchantBases = () => {
      const cachefront = (config.cachefrontUrl || 'https://cachefront.nector.io/api/v2/merchant').replace(
        /\/$/,
        ''
      );
      const platform = `${(config.platformUrl || 'https://platform.nector.io').replace(/\/$/, '')}/api/v2/merchant`;
      return cachefront === platform ? [cachefront] : [cachefront, platform];
    };

    const nectorGet = async (path, params) => {
      const requestOnce = async () => {
        let lastError = new Error('Nector reviews failed');
        for (const base of merchantBases()) {
          let response;
          try {
            response = await fetch(`${base}${path}?${params.toString()}`, {
              headers: buildHeaders(),
            });
          } catch (error) {
            lastError = error;
            continue;
          }
          let payload = null;
          try {
            payload = await response.json();
          } catch (error) {
            lastError = error;
            continue;
          }
          if (isAuthFailure(response, payload)) {
            const error = new Error('Nector reviews unauthorized');
            error.code = 'auth';
            throw error;
          }
          if (!response.ok) {
            lastError = new Error(`Nector reviews failed: ${response.status}`);
            continue;
          }
          if (payload && payload.meta && payload.meta.status && payload.meta.status !== 'success') {
            lastError = new Error(payload.meta.status);
            continue;
          }
          return payload;
        }
        throw lastError;
      };

      try {
        return await requestOnce();
      } catch (error) {
        if (includeWorkspace && error.code !== 'auth') {
          includeWorkspace = false;
          return requestOnce();
        }
        throw error;
      }
    };

    const reviewParams = (nextPage, nextSort) => {
      const params = new URLSearchParams({
        page: String(nextPage),
        limit: '50',
        sort: nextSort || sort,
        sort_op: 'DESC',
      });
      if (scopedToProduct && productId) {
        params.set('reference_product_source', 'shopify');
        params.set('reference_product_id', String(productId));
      }
      return params;
    };

    const fetchReviews = async (nextPage, nextSort) => nectorGet('/reviews', reviewParams(nextPage, nextSort));

    const fetchCount = async () => {
      try {
        const params = new URLSearchParams();
        if (scopedToProduct && productId) {
          params.set('reference_product_source', 'shopify');
          params.set('reference_product_id', String(productId));
        }
        return await nectorGet('/reviews-count', params);
      } catch (error) {
        if (error.code === 'auth') throw error;
        return null;
      }
    };

    const appendReviews = (incoming) => {
      const next = incoming
        .map(normalizeReview)
        .filter((review) => !review.hidden && review.rating);
      const existing = new Set(reviews.map((review) => `${review.author}|${review.body}`));
      next.forEach((review) => {
        const key = `${review.author}|${review.body}`;
        if (!existing.has(key)) {
          reviews.push(review);
          existing.add(key);
        }
      });
    };

    const renderPreview = () => {
      renderList(preview, reviews.slice(0, previewLimit));
      updateSummary(reviews, totalCount || reviews.length, stats);
      syncShowAll();
    };

    const modalHome = modal && modal.parentNode;
    const setModalOpen = (open) => {
      if (!modal) return;
      if (open) {
        if (modal.parentNode !== document.body) {
          document.body.appendChild(modal);
        }
        modal.hidden = false;
        document.documentElement.classList.add('bagveda-reviews-modal-open');
        renderList(allList, reviews);
        if (loadMoreBtn) loadMoreBtn.hidden = reviews.length >= totalCount;
        modal.querySelector('[data-bagveda-reviews-close]')?.focus?.();
        return;
      }
      modal.hidden = true;
      document.documentElement.classList.remove('bagveda-reviews-modal-open');
      if (modalHome && modal.parentNode !== modalHome) {
        modalHome.appendChild(modal);
      }
    };

    const applyListPayload = (listPayload, countPayload) => {
      appendReviews(getItems(listPayload));
      const nextStats = getStats(listPayload);
      if (nextStats.length) stats = nextStats;
      totalCount = getCount(countPayload, getCount(listPayload, reviews.length));
      if (!reviews.length) {
        setStatus(root.getAttribute('data-empty-message'));
        if (summary) summary.hidden = true;
        if (footer) footer.hidden = true;
        return;
      }
      renderPreview();
      if (modal && !modal.hidden) {
        renderList(allList, reviews);
        if (loadMoreBtn) loadMoreBtn.hidden = reviews.length >= totalCount;
      }
      setStatus('');
    };

    const loadInitial = async () => {
      scopedToProduct = true;
      const [firstList, countPayload] = await Promise.all([fetchReviews(1, sort), fetchCount()]);
      let listPayload = firstList;
      const productCount = getCount(countPayload, getCount(listPayload, 0));
      if (!getItems(listPayload).length && productCount === 0) {
        if (allowAllFallback) {
          scopedToProduct = false;
          listPayload = await fetchReviews(1, sort);
        } else if (sort !== 'image_count') {
          sort = 'image_count';
          listPayload = await fetchReviews(1, sort);
        }
      }
      page = 1;
      applyListPayload(listPayload, scopedToProduct ? countPayload : listPayload);
    };

    const loadPage = async (nextPage) => {
      if (loading) return;
      loading = true;
      try {
        const payload = await fetchReviews(nextPage);
        page = nextPage;
        applyListPayload(payload, null);
      } finally {
        loading = false;
      }
    };

    const start = async () => {
      if (!config.apiKey && window.bagvedaNector && typeof window.bagvedaNector.resolveApiKey === 'function') {
        config.apiKey = window.bagvedaNector.resolveApiKey();
      }
      leadToken = window.nector?.lead_token || window.nector?.leadToken || null;
      try {
        await loadInitial();
      } catch (error) {
        if (error.code === 'auth') {
          leadToken = await waitForLeadToken(8000);
          try {
            await loadInitial();
            return;
          } catch (retryError) {
            setStatus(root.getAttribute('data-error-message'));
            return;
          }
        }
        setStatus(root.getAttribute('data-error-message'));
      }
    };

    showAllBtn?.addEventListener('click', async () => {
      setModalOpen(true);
      if (reviews.length < totalCount) {
        await loadPage(page + 1).catch(() => {});
      }
    });

    loadMoreBtn?.addEventListener('click', () => {
      loadPage(page + 1).catch(() => {});
    });

    root.querySelectorAll('[data-bagveda-reviews-close]').forEach((button) => {
      button.addEventListener('click', () => setModalOpen(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal && !modal.hidden) setModalOpen(false);
    });

    start();
  };

  document.querySelectorAll('[data-bagveda-pdp-reviews]').forEach(init);
})();
